import React from 'react';
import PropTypes from 'prop-types';

import { Button as AppkitButton } from '@pwc/appkit-react/lib/Button';

const Button = ({
  children,
  className,
  disabled,
  onClick,
  onMouseDown,
  kind,
  negative,
  type,
  isLoading,
}) => (
  <AppkitButton
    className={className}
    disabled={disabled}
    onClick={onClick}
    onMouseDown={onMouseDown}
    kind={kind}
    negative={negative}
    type={type}
    isLoading={isLoading}
  >
    {children}
  </AppkitButton>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func,
  kind: PropTypes.oneOf(['primary', 'secondary', 'transparent']),
  negative: PropTypes.bool,
  type: PropTypes.oneOf(['submit', 'reset', 'button']),
  isLoading: PropTypes.bool,
};

Button.defaultProps = {
  className: '',
  disabled: false,
  type: 'button',
  isLoading: false,
};

export default Button;
